import { TextField } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { useSelector, useDispatch } from "react-redux"
import { obtenerDevolucionesPendientesBusquedaAction } from "../../../ducks/devolucionesDuck"
import handleRenderOption from "./handleRenderOption"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import { useState } from "react"

const FiltroDevoluciones = () => {
    const { listaDevolucionesCombo } = useSelector(store => store.devolucionesPendientes)
    const dispatch = useDispatch()
    const getOptionHangle = (event, valor) => {
        if (valor) {
            dispatch(onLoadAnction({ message: "" }))
            dispatch(obtenerDevolucionesPendientesBusquedaAction({ Referencia: valor?.Referencia })).then(Response => {
                dispatch(offLoadAction())
            })
        } else {
            dispatch(obtenerDevolucionesPendientesBusquedaAction({Referencia: "0"}))
        }
    }
    return (
        <div style={{ margin: "2% 0", width: "400px" }}>
            <Autocomplete
                id={`id-auto-Clientes`}
                options={listaDevolucionesCombo.sort((a, b) => a.Nombre > b.Nombre)}
                getOptionLabel={(option) => {
                    let nombre = `${option?.Nombre.trim()} ${option?.Apellidos.trim()}`
                    return `${option.Referencia} - ${nombre}`
                }}
                style={{
                    width: "97%",
                    margin: "2% 0",
                    paddingBottom: "0",
                    fontWeight: "500",
                }}
                disabled={listaDevolucionesCombo.length > 0 ? false : true}
                onChange={getOptionHangle}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Clientes"
                        variant="outlined"
                        style={{ width: "100%" }}
                        name="clientes"
                    />
                )}
                renderOption={handleRenderOption}
            />
        </div>
    )
}
export default FiltroDevoluciones